<template>
	<v-dialog v-model="dialog" max-width="500px">
		<v-card>
			<v-card-title>
				<span class="headline"> Zmiana e-maila / loginu </span>
			</v-card-title>

			<v-card-text>
				<v-flex xs12>
					<v-text-field
						browser-autocomplete="off"
						name="Stary e-mail"
						label="Stary e-mail"
						aria-label="old email"
						for="reset-email-dialog-old-mail"
						id="reset-email-dialog-old-mail"
						v-model="formData.oldEmail"
						data-vv-name="oldEmail"
						data-vv-as="Stary e-mail"
						:error-messages="vErrors.collect('oldEmail')"
						@click="disableErrorMessage"
						v-validate="'required|email'"
						data-vv-validate-on="none"
					></v-text-field>
				</v-flex>
				<v-flex xs12>
					<v-text-field
						browser-autocomplete="off"
						name="Nowy e-mail"
						label="Nowy e-mail"
						aria-label="new email"
						for="reset-email-dialog-new-mail"
						id="reset-email-dialog-new-mail"
						v-model="formData.newEmail"
						data-vv-name="newEmail"
						data-vv-as="Nowy e-mail"
						:error-messages="vErrors.collect('newEmail')"
						@click="disableErrorMessage"
						v-validate="'required|email'"
						data-vv-validate-on="none"
					></v-text-field>
				</v-flex>
				<v-flex xs12>
					<v-text-field
						browser-autocomplete="off"
						name="Potwierdź nowy e-mail"
						label="Potwierdź nowy e-mail"
						aria-label="new email confirmation"
						for="reset-email-dialog-confirm-new-mail"
						id="reset-email-dialog-confirm-new-mail"
						v-model="formData.confirmationEmail"
						data-vv-name="confirmationEmail"
						data-vv-as="Potwierdź nowy e-mail"
						:error-messages="vErrors.collect('confirmationEmail')"
						@click="disableErrorMessage"
						v-validate="'required|email'"
						data-vv-validate-on="none"
					></v-text-field>
				</v-flex>
				<v-expand-transition>
					<div v-show="showErrorMessage" style="color: red">
						{{errorMessage}}
					</div>
				</v-expand-transition>
			</v-card-text>

			<v-dialog v-model="emailResetConfirmationDialog" persistent max-width="600px">
				<v-card>
					<div class="mt-1">
						<v-alert
							:value="true"
							color="info"
						>
							Czy na pewno chcesz zmienić adres e-mail / login?
						</v-alert>
					</div>
					<v-card-text>Po zatwierdzeniu na nowy adres zostanie wysłany link weryfikacyjny oraz nastąpi
						wylogowanie z systemu.
					</v-card-text>
				<v-card-actions>
						<v-spacer/>
						<v-btn color="blue darken-1"
							flat
							@click="emailResetConfirmationDialog = false">
							Nie
						</v-btn>
						<v-btn color="blue darken-1"
							flat
							@click="sendEmailResetRequest">
							Tak
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>

			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="blue" @click="closeDialog">Anuluj</v-btn>
				<v-btn color="primary" flat @click="resetEmail">Zapisz</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
	import {Credentials} from "@/api/generated/Credentials";
	import {User} from "@/api/generated/User";
	import {encoder} from "@/utils/encodeHelper";
	import Vue from "vue";

	export default {
		name: "ResetEmailDialog",

		data () {
			return {
				formData: {
					oldEmail: '',
					newEmail: '',
					confirmationEmail: ''
				},
				dialog: true,
				errorMessage: '',
				showErrorMessage: false,
				emailResetConfirmationDialog: false
			};
		},

		methods: {

			closeDialog () {
				this.dialog = false;
			},

			disableErrorMessage () {
				this.showErrorMessage = false;
			},

			resetEmail () {
				this.$validator.validateAll().then((result) => {
					if (!result) return;
					if (!this.emailsMatch()) {
						this.errorMessage = 'Podane adresy e-mail muszą być identyczne';
						this.showErrorMessage = true;
						return;
					}
					User.getValidateEmailEdition(this, encoder.encodeUrlParam(this.formData.newEmail), successResponse => {
						if (successResponse === true) {
							this.emailResetConfirmationDialog = true;
						} else {
							this.errorMessage = 'Podany e-mail już istnieje w systemie!';
							this.showErrorMessage = true;
						}
					}, errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się zwalidować e-mail", errorResponse);
					});
				});
			},

			sendEmailResetRequest () {
				this.emailResetConfirmationDialog = false;
				Credentials.putResetEmail(this, this.formData, successResponse => {
						this.closeDialog();
						sessionStorage.removeItem("access_token");
						sessionStorage.removeItem("role");
						Vue.prototype.$keycloak.keycloak.logout({ redirectUri: process.env.VUE_APP_APP_URL });
					},
					errorResponse => {
						this.errorMessage = errorResponse.errors[0];
						this.showErrorMessage = true;
					});
			},

			emailsMatch () {
				return this.formData.newEmail === this.formData.confirmationEmail;
			}
		},

		watch: {
			dialog (val) {
				!val && this.$emit("closeDialog") && this.vErrors.clear();
			}
		}
	};
</script>

<style scoped>

</style>
